'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _NavigationBarControl = require('../../../lib/ui/NavigationBarControl');

var _NavigationBarControl2 = _interopRequireDefault(_NavigationBarControl);

var _CheckboxControl = require('../../../lib/ui/CheckboxControl');

var _CheckboxControl2 = _interopRequireDefault(_CheckboxControl);

var _CsvExporter = require('../exporters/CsvExporter');

var _CsvExporter2 = _interopRequireDefault(_CsvExporter);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var ReportPeople = function ReportPeople(element) {
  var _this = this;

  _classCallCheck(this, ReportPeople);

  var fragment = document.createDocumentFragment();
  new _NavigationBarControl2.default(fragment, {
    title: 'Personen rapportage',
    leftHandButtons: [{
      onclick: function onclick() {
        history.back();
      },
      icon: '\uE00D'
    }]
  });

  var createReport = function createReport() {
    if (!_this.sendbirthdaycard.getValue() && !_this.sendbirthdayemail.getValue() && !_this.sendchristmascard.getValue() && !_this.sendchristmasemail.getValue()) {
      alert('Kies tenminste één optie.');
      return;
    }

    window.PRIM.dataAccess.resolve('people').then(function (people) {
      var filtered = people.filter(function (person) {
        return _this.sendbirthdayemail.getValue() === true && person.values.sendbirthdayemail === true || _this.sendbirthdaycard.getValue() === true && person.values.sendbirthdaycard === true || _this.sendchristmasemail.getValue() === true && person.values.sendchristmasemail === true || _this.sendchristmascard.getValue() === true && person.values.sendchristmascard === true;
      });

      if (filtered.length === 0) {
        alert('Er zijn geen personen die voldoen aan de gekozen opties.');
        return;
      }

      var exporter = new _CsvExporter2.default();
      var csv = exporter.export(['nickname', 'suffix', 'lastname', 'address', 'zipcode', 'city', 'country', 'email', 'phone', 'mobile'], filtered);
      var blob = new Blob([csv], { type: 'text/csv' });
      if (navigator.msSaveOrOpenBlob) {
        navigator.msSaveBlob(blob, 'export.csv');
      } else {
        var url = URL.createObjectURL(blob);
        var tempAnchor = document.createElement('a');
        tempAnchor.href = url;
        tempAnchor.download = 'export.csv';
        tempAnchor.className = 'invisible';
        document.body.appendChild(tempAnchor);
        tempAnchor.click();
        document.body.removeChild(tempAnchor);
        URL.revokeObjectURL(url);
      }
    }, function (e) {
      alert('Er is iets fout gegaan tijdens het maken van het rapport. Probeer het opnieuw.');
    });
  };

  var div = document.createElement('div');
  div.className = 'viewport';

  var fieldsetOptions = document.createElement('fieldset');
  var legendOptions = document.createElement('legend');
  legendOptions.innerHTML = 'Opties';
  fieldsetOptions.appendChild(legendOptions);

  this.sendbirthdayemail = new _CheckboxControl2.default(fieldsetOptions, { label: 'Verjaardagskaart per e-mail', readonly: window.PRIM.hasReadonlyModuleAccess('people') });
  this.sendbirthdaycard = new _CheckboxControl2.default(fieldsetOptions, { label: 'Verjaardagskaart per post', readonly: window.PRIM.hasReadonlyModuleAccess('people') });
  this.sendchristmasemail = new _CheckboxControl2.default(fieldsetOptions, { label: 'Kerstkaart per e-mail', readonly: window.PRIM.hasReadonlyModuleAccess('people') });
  this.sendchristmascard = new _CheckboxControl2.default(fieldsetOptions, { label: 'Kerstkaart per post', readonly: window.PRIM.hasReadonlyModuleAccess('people') });

  var button = document.createElement('button');
  button.innerHTML = 'Maak rapport';
  button.onclick = createReport;

  div.appendChild(fieldsetOptions);

  div.appendChild(button);
  fragment.appendChild(div);

  element.appendChild(fragment);
};

exports.default = ReportPeople;


//////////////////
// WEBPACK FOOTER
// ./js/modules/report/action/ReportPeople.js
// module id = 26
// module chunks = 0